module.exports = __webpack_public_path__ + "img/FOX BOXING 1.jpg";